import React, { memo } from 'react';
import PropTypes from 'prop-types';

//TODO: remove old svg file
//TODO: Add tooltip

const defaultStrokeColor='#447d98';
const defaultFillColor='transparent';
const favoriteStrokeColor='transparent';
const favoriteFillColor='#ecd921';

export const FavoriteLocationIcon = memo(({ width=17, height=17, isFavoriteLocation=false }) => {
    return (
        <svg width={width} height={height}
            stroke={isFavoriteLocation ? favoriteStrokeColor : defaultStrokeColor}
            fill={isFavoriteLocation ? favoriteFillColor : defaultFillColor} version='1.1' id='Layer_1' x='0px' y='0px'
            viewBox='0 0 13.6 13' enableBackground='new 0 0 13.6 13'>
            <path fillRule='evenodd' clipRule='evenodd' d='M6.8,10.2l-3.7,2.6c-0.5,0.3-0.7,0.1-0.5-0.4l1.3-4.3L0.3,5.4
            C-0.2,5-0.1,4.8,0.5,4.7L5,4.7l1.5-4.3c0.2-0.5,0.5-0.5,0.7,0l1.5,4.3l4.5,0.1c0.6,0,0.6,0.3,0.2,0.6L9.7,8.1l1.3,4.3
            c0.2,0.5-0.1,0.7-0.5,0.4L6.8,10.2L6.8,10.2z'/>
        </svg>
    );
});

FavoriteLocationIcon.displayName = 'FavoriteLocationIcon';

FavoriteLocationIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    isFavoriteLocation: PropTypes.bool
};
